<template>
  <component :is="receiptData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->

    <b-alert variant="danger" :show="receiptData === undefined">
      <h4 class="alert-heading">取得入倉資料時出錯</h4>
      <div class="alert-body">
        找不到具有該 ID 的入倉記錄。查看
        <b-link class="alert-link" :to="{ name: 'stock-receive' }">
          入倉列表
        </b-link>
      </div>
    </b-alert>

    <b-tabs v-if="receiptData" pills>
      <!-- Tab: Information -->
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">入倉資料</span>
        </template>
        <receipt-edit-tab-information
          :receipt-data="receiptData"
          :supplier-options="supplierOptions"
          @refetch-data="refetchData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import receiptStoreModule from "../receiptStoreModule";
import ReceiptEditTabInformation from "./ReceiptEditTabInformation.vue";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    ReceiptEditTabInformation,
  },
  setup() {
    const receiptData = ref(null);

    const USER_APP_STORE_MODULE_NAME = "app-receipt";

    const itemFormBlankItem = {
      product_id: null,
      description: "",
      unit_price: 0,
      quantity: 1,
    };

    const receipt = {
      id: 0,
      supplier_id: null,
      receipt_date: null,
      remark: "",
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
    };

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, receiptStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    onMounted(() => {
      refetchOptions();
    });

    const refetchData = () => {
      if (router.currentRoute.name == "stock-receive-create") {
        receiptData.value = receipt;
      } else {
        store
          .dispatch("app-receipt/fetchReceipt", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            receiptData.value = response.data.receipt;
            receiptData.value.is_active =
              receiptData.value.is_active == 1 ? true : false;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              receiptData.value = undefined;
            }
          });
      }
    };

    refetchData();

    const supplierOptions = ref([]);
    const refetchOptions = () => {
      store
        .dispatch("app/fetchOptionList", { supplier: true })
        .then((response) => {
          supplierOptions.value = response.data.suppliers;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    return {
      receiptData,
      refetchData,
      supplierOptions,
    };
  },
};
</script>

<style></style>
